import { useCallback, useRef } from 'react';

export const useRequestTracker = (): {
  startRequest: () => () => boolean;
} => {
  const latestRequestId = useRef(0);

  const startRequest = useCallback((): (() => boolean) => {
    latestRequestId.current += 1;
    const requestId = latestRequestId.current;

    return () => requestId !== latestRequestId.current;
  }, []);

  return { startRequest };
};
